import './App.css';
import React, {useState} from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api, legacyPhpUrl, openGunlukRapor, getSessionUserId, visitReportUrl } from "./api/client";
import { pageTitle, reportLinkText } from "./i18n/messages";
import {adaptV4Theme, createTheme, ThemeProvider} from '@mui/material/styles';
import Button from '@mui/material/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import moment from "moment";
import ReplayIcon from "@mui/icons-material/Replay";
import ModalBoxOnayla from "./ModalboxOnayla";
import ModalboxReddedilen from "./ModalboxReddedilen";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import IconButton from "@mui/material/IconButton";
import { Dialog,DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@material-ui/core";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import trLocale from "date-fns/locale/tr";
import {DatePicker} from "@mui/lab";
import ModalboxEkler from "./ModalboxEkler";
import {DeleteForever} from "@material-ui/icons";
import ModalBoxDurum from "./ModalboxDurum";
import { parsePersoneller, personelFilterListOptions, personelFilterOptions } from "./utils/personelFilter";
import Tooltip from '@mui/material/Tooltip';
import { codeList, machineNameList, enhanceColumns, renderIsEmriNo, withTableOptions } from "./utils/tableDisplay";
import { parseListResponse, buildPageParams, withServerSideOptions, makeServerTableHandler } from "./utils/serverSideTable";
import { applyFilterFacets, fetchIsEmriFilterOptions, fetchPersonelFilterNames } from "./utils/filterFacets";
import { formatIsEmriTipi, tipColumn, tipFiltersToParams } from "./utils/isEmriTipi";

class IsEmirleriOnayli extends React.Component {
    constructor(props) {
        super(props);
        this.state={ filterOpts: {}, count: 0, page: 0, rowsPerPage: 50, search: '', filters: {}, replace: "", datas:[], open:false, id:"", deleteDialogOpen:false,user_id:""};
    }
    async getDatas(){
        let user_id= getSessionUserId();
        const pageParams = buildPageParams({
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            search: this.state.search,
            filters: this.state.filters,
            sortBy: this.state.sortBy,
            sortDir: this.state.sortDir,
            extra: {},
        });
        if (user_id) pageParams.user_id = user_id;
        const res = await api.get('/is-emirleri/durum/Final', { params: pageParams })
        const { items: data, count } = parseListResponse(res)

        const products = data.map(d => ({
            "id":d.id ,
            "is_emri_no" :  d.is_emri_no,
            "is_emri_baslangic_tarihi":d.is_emri_baslangic_tarihi ,
            "is_emri_bitis_tarihi" : d.is_emri_bitis_tarihi ,
            "musteri" :  d.musteri,
            "lokasyon": d.lokasyon,
            "uyfler" :  d.uyfler,
            "seri_nolar" :  d.seri_nolar,
            "teklif_no": d.teklif_no,
            "tip": formatIsEmriTipi(d),
            "makineler" :  d.makineler,
            "temsilci": d.temsilci,
            "teknik_personeller":d.teknik_personeller,
            "dil":d.dil,
            "iletilen_problemler":d.iletilen_problemler,
            "ziyaret_raporlari":d.ziyaret_raporlari,
            "is_unread": d.is_unread,

        }))
        //console.log(products);
        //console.log(products);
        this.setState({ datas: products, count })
        this.setState({user_id: user_id})
    }

    async taslaklaraGeriAl(value) {

        await api.post('/is-emirleri/' + value + '/onay-geri-al')
            .then((response) => {
                // Success 🎉
                console.log(response);
                 toast.success("Geri alma işlemi başarılı");
                const { datas } = this.state;
                datas.shift();
                this.setState({ datas:datas, open:false });
                window.location.reload();
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }


    async reddet(value) {

        await api.post('/is-emirleri/' + value + '/iptal', { notu: '' }).then((response) => {
                // Success 🎉
                console.log(response);
                toast.success("İş emri iptal edilenler arasına taşındı");
                const { datas } = this.state;
                datas.shift();
                this.setState({ datas });
            }).catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }


    
    async loadFilterOptions() {
        try {
            const [opts, personel] = await Promise.all([
                fetchIsEmriFilterOptions('Final'),
                fetchPersonelFilterNames(),
            ]);
            this.setState({ filterOpts: { ...opts, personel } });
        } catch (e) {
            console.warn('filter options', e);
        }
    }

    componentDidMount() {
        this.loadFilterOptions();
        this.getDatas(true);
    }
    componentDidUpdate(prevProps,prevState,snapshot) {
            //this.getDatas(true);
    }

    onaylananlara = (data) => {
        this.getDatas();
        toast.success("Onaylananlar aşamasına geçme işlemi başarılı");

    }
    reddedilmis = (data) => {
        window.location.reload()
    }
    handleClose() {
        this.setState({open:false})
    }

    render() {
        const theme  = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },

            },
        }));
        Date.prototype.addDays = function (days) {
            let date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        const data = this.state.datas;
        const columns = [
            {
                name: "id",
                label: "İşlemler",
                options: {
                    filter: false,
                    sort: false,
                    setCellProps: () => ({ style: { whiteSpace: 'nowrap', width: 1 } }),
                    customBodyRender: (value, tableMeta) => {
                        const record = data[tableMeta.currentTableData[tableMeta.rowIndex].index];
                        const isEmriNo = record.is_emri_no;
                        const result = value ? this.state.datas.find(p => p.id === value) : null;
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
                                {isEmriNo && (
                                    <Tooltip title="Düzenle"><span>
                                        <IconButton size="small" href={`/is-emri-duzenle/${isEmriNo}/onayli-is-emirleri`} color={'primary'} variant="outlined" target="_blank">
                                            <EditIcon />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                                {value && result && (
                                    <ModalBoxDurum id={value} musteri={result.musteri} is_emri_no={result.is_emri_no} />
                                )}
                                <ModalboxReddedilen id={record.id} reddEdilmis={this.reddedilmis} tur={'is-emri'} />
                                {value && (
                                    <Tooltip title="Sil"><span>
                                        <IconButton size="small" style={{ width: 30 }} onClick={() => { this.setState({ deleteDialogOpen: true, id: value }); }} color="error" variant="outlined">
                                            <DeleteForever />
                                        </IconButton>
                                    </span></Tooltip>
                                )}
                            </div>
                        );
                    },
                },
            },
            {
                name: "is_emri_no",
                label: "İş Emri No",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta) => {
                        const row = tableMeta.currentTableData && tableMeta.currentTableData[tableMeta.rowIndex];
                        const record = row ? data[row.index] : data[tableMeta.rowIndex];
                        return renderIsEmriNo(value, record && record.teklif_no);
                    },
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "is_emri_baslangic_tarihi",
                label: "Başlangıç Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                },
            },
            {
                name: "is_emri_bitis_tarihi",
                label: "Bitiş Tarihi",
                options: {
                    filter: false,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );
                        }
                    },
                }
            },
            {
                name: "teknik_personeller",
                label: "Personel",
                options: {
                    filter: true,
                    filterOptions: personelFilterOptions(data),
                    customFilterListOptions: personelFilterListOptions,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const personel = parsePersoneller(value);
                        if (personel.length > 0) {
                            return (
                                personel.join(" , ")
                            );

                        }
                    }
                }
            },
            {
                name: "musteri",
                label: "Müşteri",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                value.substring(0, value.indexOf(' '))
                            );

                        }
                    }
                }
            },
            {
                name: "lokasyon",
                label: "Lokasyon",
                options: {
                    /*customBodyRenderLite: (dataIndex) => {
                        let val = data[dataIndex][3];
                        return val;
                    },*/
                    filter: false,
                }
            },
            {
                name: "makineler",
                label:"Makine",
                options: {
                    filter: false,
                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let makineler=machineNameList(value)
                        if (value) {
                            return (
                                makineler.join(" , ")
                            );

                        }
                    }
                }
            },
            {
                name: "uyfler",
                label:"UYF No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let uyfler=codeList(value)
                        if (value) {
                            return (
                                uyfler.join("   ")
                            );

                        }
                    }
                }
            },
            {
                name: "seri_nolar",
                label:"Seri No",
                options: {
                    filter: true,

                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let uyfler=codeList(value)
                        if (value) {
                            return (
                                uyfler.join("   ")
                            );

                        }
                    }
                }
            },
            tipColumn,
            {
                name: "iletilen_problemler",
                label:"İletilen Problemler",
                options: {
                    filter:false,
                    sort:true,
                }
            },

            {
                name: "temsilci",
                label:"Temsilci",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },

                    //customFilterListOptions: { render: v => `Salary: ${v}` },
                    sort: false
                }
            },

            {
                name: "is_emri_no",
                label: "Günlük Rapor",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {
                            const record = data[meta.currentTableData[meta.rowIndex].index];
                            return (
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openGunlukRapor(value, this.state.user_id);
                                    }}
                                >
                                    Aç
                                </a>
                            );

                        }
                    },
                    customFilterListOptions: {render: v => `Teklif NO: ${v}`},
                },
            },
            {
                name: "ziyaret_raporlari",
                label: "Ziyaretçi Raporu",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        if (value) {
                            const data = value.split(',');
                            ; // Verileriniz burada
                            return (
                                <div>
                                    {data.map((id, index) => (
                                            <a
                                                key={id}

                                                rel="noopener noreferrer" // Güvenlik için

                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(visitReportUrl(id), '_blank');
                                                    setTimeout(()=> {
                                                        window.location.reload();
                                                    },1000) // Mevcut sayfayı yenile
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: 'block', marginBottom: '10px',
                                                    color: 'orange',

                                                }}
                                            >
                                                {reportLinkText(index + 1)}
                                            </a>
                                        )
                                    )}
                                </div>
                            )
                                ;

                        }
                    },
                },
            },

            {
                name: "is_unread",
                options: {
                    display: 'excluded' // tabloya görünmez ama row[]'da olur
                }
            }


        ];

        let datas=[];
        const options = {
            sortOrder: { name: "is_emri_baslangic_tarihi", direction: "desc" },
            filter: true,

            setRowProps: (row) => {
                const isUnread = row[columns.findIndex(col => col.name === 'is_unread')];
                if (Number(isUnread) > 0) {
                    return {
                        style: {
                            backgroundColor: '#f3cd72',
                            fontWeight: 'bold'
                        }
                    };
                }
                return {};
            },
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: this.state.rowsPerPage,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
                lineHeight:0.1
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Taslak İş Emirleri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },

        };

        async  function handleDeleteIsEmri(id,correct) {
            await api.delete('/is-emirleri/' + id)
                .then((response) => {
                    // Success 🎉
                    console.log('sildini',response)
                    window.location.reload()
                })
                .catch((error) => {
                    // Error 😨
                    if (error.response) {
                        /*
                         * The request was made and the server responded with a
                         * status code that falls out of the range of 2xx
                         */
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        /*
                         * The request was made but no response was received, `error.request`
                         * is an instance of XMLHttpRequest in the browser and an instance
                         * of http.ClientRequest in Node.js
                         */
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request and triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });

        }

        return (

            <ThemeProvider theme={theme}>


                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover

                />
                <MUIDataTable title={pageTitle("Final İş Emirleri")} data={data} columns={enhanceColumns(applyFilterFacets(columns, this.state.filterOpts))} options={withTableOptions(withServerSideOptions(options, {
                    count: this.state.count,
                    page: this.state.page,
                    rowsPerPage: this.state.rowsPerPage,
                    sortBy: this.state.sortBy,
                    sortDir: this.state.sortDir,
                    onServerTableChange: makeServerTableHandler(this),
                }))} />
                <Dialog
                    open={this.state.open}
                    onClose={()=>{this.handleClose(true)}}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                >
                <DialogTitle id="form-dialog-title">Taslaklara Geri Gönder</DialogTitle>
                <DialogContent>
                Onaylıyor musunuz?
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{this.handleClose(true)}} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={ ()=>{ this.taslaklaraGeriAl(this.state.id,true).then(r=>console.log(r)) }}
                        color="primary"
                    >
                        Gönder
                    </Button>
                </DialogActions>
            </Dialog>
                <Dialog
                    open={this.state.deleteDialogOpen}
                    onClose={()=>{this.setState({deleteDialogOpen:false})}}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">İş Emrini Tamamen Sil</DialogTitle>
                    <DialogContent>
                        Onaylıyor musunuz?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{this.setState({deleteDialogOpen:false})}} color="primary">
                            İptal
                        </Button>
                        <Button

                            onClick={ ()=>{ handleDeleteIsEmri(this.state.id,true) }}
                            color="primary"
                        >
                            Sil
                        </Button>
                    </DialogActions>
                </Dialog>

            </ThemeProvider>
        );

    }


}

export default IsEmirleriOnayli;
